<template>
  <div>
    <v-img class="white--text align-end" :src="this.imageSource" height="10em" width="100%">
      <v-container fluid>
        <v-row>
          <v-col offset-md="0" md="12" offset-lg="1" lg="10">
            <h1 class="outlined">{{ this.headerTitle }}</h1>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <v-container class="mt-5" fluid>
      <v-row>
        <v-col offset-md="0" md="12" offset-lg="1" lg="10">
          <slot></slot>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ImageHeader",
  props: {
    imageSource: { type: String, required: true },
    headerTitle: { type: String, required: true }
  },
  data: function() {
    return {
    }
  },
}
</script>

<style scoped>
.outlined {
  text-shadow: 1px 0 0 #000, 0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000;
}
</style>